import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RolService } from 'src/app/services/rol.service';

// SERVICIOS
import { TiposOperacionesService } from 'src/app/services/tipos_operaciones.service';
import { ChannelsandoperationsService } from 'src/app/services/channelsandoperations.service';

// MODALES
import { TipoOperacionComponent } from '../../dialogs/crear/tipo-operacion/tipo-operacion.component';
import { EditarTipoOperacionComponent } from '../../dialogs/editar/editar-tipo-operacion/editar-tipo-operacion.component';
import { DesicionComponent } from '../../dialogs/desicion/desicion.component';

// TABLE
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-tipos-operaciones',
  templateUrl: './tipos-operaciones.component.html',
  styleUrls: ['./tipos-operaciones.component.scss'],
})
export class TiposOperacionesComponent implements OnInit {
  tipos_operaciones: any = [];
  idUser;
  idCanal;
  canal;

  // TABLE
  buscar = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['nombre', 'estatus', 'opciones'];
  dataSource = new MatTableDataSource();

  crearTipos: boolean = false;
  actualizarTipos: boolean = false;
  eliminarTipos: boolean = false;

  constructor(
    private channelAndOperationService: ChannelsandoperationsService,
    private tiposOperacionesService: TiposOperacionesService,
    private actRoute: ActivatedRoute,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private rolService: RolService,

  ) {
    //console.log(this.rolService.permisos)
    let permisos = this.rolService.permisos;
    for (let i in this.rolService.permisos) {
      permisos[i].indexOf("Crear Tipos") !== -1 ? this.crearTipos = true : null
      permisos[i].indexOf("Actualizar Tipos") !== -1 ? this.actualizarTipos = true : null
      permisos[i].indexOf("Eliminar Tipos") !== -1 ? this.eliminarTipos = true : null
    }
    this.idUser = sessionStorage.getItem('id_usuario');
    this.idCanal = sessionStorage.getItem('id_canales');
    this.channelAndOperationService
      .getChannelsById(this.idCanal)
      .subscribe((data: any) => {
        this.canal = data.payload.nombre;
      });
    this.getTiposOperaciones();
  }

  ngOnInit(): void { }

  getTiposOperaciones() {
    this.tiposOperacionesService
      .obtenerId(this.idCanal)
      .subscribe(async (tiposOperaciones: any) => {
        //console.log(tiposOperaciones);
        this.tipos_operaciones = tiposOperaciones.payload.data;
        this.dataSource = new MatTableDataSource(this.tipos_operaciones);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }
  search() {
    this.dataSource.filter = this.buscar;
  }

  crear() {
    const dialogRef = this.dialog.open(TipoOperacionComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getTiposOperaciones();
    });
  }

  editar(channel) {
    //console.log(channel);
    const dialogRef = this.dialog.open(EditarTipoOperacionComponent, {
      width: '500px',
      data: channel,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getTiposOperaciones();
    });
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  eliminar(id_tipo_operacion) {
    const dialogRef = this.dialog.open(DesicionComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      //console.log(result);
      if (result == 'true') {
        //console.log('Borrando');
        this.tiposOperacionesService
          .eliminar(id_tipo_operacion)
          .subscribe((data) => {
            //console.log(data);
          });
        this.openSnackBar('Rol eliminado con éxito.', 'X');
      } else {
      }
      this.getTiposOperaciones();
    });
  }
}
